// ----------------------------------------------------------------------


function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),

};

export const PATH_PAGE = {

};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    ads:path(ROOTS_DASHBOARD, '/ads'),
    offers:path(ROOTS_DASHBOARD, '/offers'),
    placements:path(ROOTS_DASHBOARD, '/placements'),
    createAd: path(ROOTS_DASHBOARD, "/createAd"),
    offer: path(ROOTS_DASHBOARD, "/offer"),
    creativeMethod: path(ROOTS_DASHBOARD, "/creativeMethod"),
    creativeUploads: path(ROOTS_DASHBOARD, '/creativeUploads')
  },

};

export const PATH_DOCS = 'https://todo.com/';
